import { createBasicSelector } from 'util/redux'
import { selectPlans } from './selectPlans'
import { INBOX } from '../productTypes'

export const selectIsFreemium = createBasicSelector(selectPlans, plans =>
  plans.some(
    ({ pricing: { type, monthly } }) => [INBOX].includes(type) && monthly === 0
  )
)
